/* Prop & Grow — email signup boxes: submit without leaving the page. */
(() => {
  if (window.PGSignup) return;
  window.PGSignup = true;

  const done = form => {
    form.innerHTML = `
      <div class="pgsu__done" role="status">
        <span class="pgsu__done-icon" aria-hidden="true">✓</span>
        <div><strong>You're on the list!</strong><span>Look out for our next restock email.</span></div>
      </div>`;
  };

  document.addEventListener('submit', async event => {
    const form = event.target.closest && event.target.closest('.pgsu__form');
    if (!form || form.dataset.native === '1') return;
    event.preventDefault();

    const button = form.querySelector('.pgsu__button');
    const msg = form.querySelector('[data-pgsu-msg]');
    const showMsg = text => { if (msg) { msg.textContent = text; msg.hidden = false; } };
    const native = () => { form.dataset.native = '1'; HTMLFormElement.prototype.submit.call(form); };

    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Joining…'; }
    if (msg) msg.hidden = true;

    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      // Shopify sometimes asks for a captcha: hand over to a normal page submit.
      if (res.url.includes('/challenge')) return native();
      if (res.url.includes('customer_posted=true')) return done(form);
      showMsg('Please check your email address and try again.');
    } catch (e) {
      return native();
    }
    if (button) { button.disabled = false; button.textContent = button.dataset.label || 'Join the list'; }
  });
})();
